import React, { Component } from "react";
import { Button, Form, Modal } from "react-bootstrap";
// import AuthService from "../../session/AuthService";
// import ManageUserService from "../../api/ManageUserService";







class FilterModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterby: "Status",
      filterValue : "" ,
      colorChange2: false,
      colorChange3 : false,
      commonFilterArray :[]
    };
  }


  componentDidMount () {
    this.setState({
      colorChange3 : true,
      colorChange2: true
    })

   
  }

 
  



  render() {
     
    console.log("heeeloee in props values" , this.props)
    const { colorChange2  } = this.state;

    return (
      <>
        <Modal show={this.props.show} onHide={this.props.handleClose}  backdrop="static">
          <Modal.Header closeButton>
            <span style={{fontWeight : "bolder"}}>Filter Task </span>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
              <Form.Label>Filter</Form.Label>
              <select
                class="form-select form-select-sm"
                aria-label=".form-select-sm example"
                id="form-select-sm-employee"
                name="filterby"
                value={this.props.filterby}
                onChange={(e) => this.props.onFilterByChange(e)}
                style={{ color: colorChange2 ? "black" : "#747c84" }}
              >
               
                <option value={"Category"}>Category</option>
               <option value={"Status"}>Status</option> 
                <option value={"Employee"}>Employee</option>
           
              </select>
            </Form.Group>
          
           {this.state.filterby !== "none" && (
            <Form.Group className="mb-2" controlId="exampleForm.ControlInput2">
            <Form.Label>Filter By</Form.Label>
            <select
              class="form-select form-select-sm"
              aria-label="form-select-sm example"
              id="form-select-sm-employee"
              name="filterValue"
              value={this.props.filterValue}
              onChange={ (e) => this.props.onFilterByChangeValue(e)}
              style={{ color: this.props.colorChange3 ? 'black' : '#747c84' }}
            >
              {/* <option>{"Choose"}</option> */}
              {String(this.props.filterby) === "Category" ? (
                // Render options when this.state.filterb === "Category"
                this.props.commonFilterArray.map((e) => (
                  <option value={e.name}>{e.name}</option>
                ))
              ) : String(this.props.filterby) === "Status" ? (
                // Render options when this.state.filterb === "Status"
                this.props.commonFilterArray.map((e) => (
                  <option key={e.id} value={e.name}>
                    {e.name}
                  </option>
                ))
              ) : String(this.props.filterby) === "Employee" ? (
                // Render options when this.state.filterb === "Employee"
                <>
                <option value={0}>All</option>
                {this.props.commonFilterArray.map((e) => (
                  <option key={e.id} value={e.firstName}>
                    {`${e.firstName} ${e.lastName || ""}`}
                  </option>
                ))}
              </>
              ) : (
                // Default rendering when none of the conditions match
                // this.state.defaultCommonArray.map((e) => (
                //   <option key={e.id} value={e.id}>
                //     {e.name}
                //   </option>
                // ))
                <></>
              )}
            </select>
          </Form.Group>
           )}
            
          </Modal.Body>
          <Modal.Footer>

            
            <Button variant="secondary" onClick={this.clearFilter}>
              Clear filter
            </Button>
            <Button variant="success" onClick={this.applyFilter}>
              {"Apply Filter"}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

 

 

  applyFilter = () => {

      this.props.filterdata(this.props.filterValue)
      this.props.handleClose();

 
};

  clearFilter = () => {
    this.props.clearfilter();
    // this.props.handleClose();
  }

}
export default FilterModal;
